'use strict';

var fragt = fragt || {};

fragt.sliders = fragt.sliders || new function () {

    this.init = function () {
        var quoteSlider = document.querySelector('.quote-slider');
        var logoSlider = document.querySelector('.logo-slider');

        if(quoteSlider != null) {
            // Quote slider
            var flkty1 = new Flickity( '.quote-slider', {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                wrapAround: true,
                arrowShape: { 
                    x0: 10,
                    x1: 50, y1: 50,
                    x2: 60, y2: 40,
                    x3: 35
                }
            });
        }
    
        if(logoSlider != null) {
            // Logo slider
            var flkty2 = new Flickity( '.logo-slider', {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                wrapAround: false,
                percentPosition: false,
                arrowShape: { 
                    x0: 10,
                    x1: 50, y1: 50,
                    x2: 60, y2: 40,
                    x3: 35
                }
            });
        }
    };
}(); 